/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { StopNodeModel } from './StopNodeModel';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import NodeWidgetHOC from '../NodeWidgetHOC/NodeWidgetHOC';
import BaseNodeWidget from '../NodeWidgetHOC/BaseNodeWidget';
import NodeTypes from '../BaseNodeModel/NodeTypes';

export class StopNodeFactory extends AbstractReactFactory {
  constructor() {
    super(NodeTypes.STOP_NODE);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  generateModel(event) {
    return new StopNodeModel();
  }

  generateReactWidget(event) {
    const setInputFields = ({ specs }) => event.model.setInputFields(specs);
    return (
      <NodeWidgetHOC node={event.model}>
        <BaseNodeWidget
          engine={this.engine}
          node={event.model}
          setInputFields={setInputFields}
        />
      </NodeWidgetHOC>
    );
  }
}
